module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('a', {
    attrs: {
      "id": "page9"
    }
  }), _vm._v("1")]), _vm._v(" "), _c('h1', {
    staticClass: "chapter1"
  }, [_vm._v("Origins I: A. K. Sarvis, M.D.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Dr. Sarvis with his bald mottled dome and savage visage, grim")]), _vm._v(" and noble as Sibelius, was out night-riding on a routine neighborhood beautification project, burning billboards along the highway—U.S. 66, later to be devoured by the superstate’s interstate autobahn. His procedure was simple, surgically deft. With a five-gallon can of gasoline he sloshed about the legs and support members of the selected target, then applied a match. Everyone should have a hobby.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the lurid glare which followed he could be seen shambling back to the Lincoln Continental Mark IV parked nearby, empty gas can banging on his insouciant shanks. A tall and ponderous man, shaggy as a bear, he cast a most impressive shadow in the light of the flames, across the arid scene of broken whiskey bottles, prickly pear and buckhorn cholla, worn-out tires and strips of retread. In the fire’s glare his little red eyes burned with a fierce red fire of their own, matching the candescent coal of the cigar in his teeth—three smoldering and fanatic red bulbs glowing through the dark. He paused to admire his work:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HOWDY PARDNER")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("WELCOME TO ALBUQUERQUE, NEW MEXICO")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("HUB OF THE LAND OF ENCHANTMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v("Headlights swept across him from the passing traffic. Derisive horns bellowed as sallow pimply youths with undescended testicles drove by in stripped-down zonked-up Mustangs, Impalas, Stringrays and Beetles, each with a lush-lashed truelove wedged hard overlapping-pelvis-style on the driver’s lap, so that seen from the back through the rear window in silhouette against oncoming headlights the car appeared to be “operated” by a single occupant with—anomaly—two heads; other lovers screamed past jammed butt to groin on the buddy seats of 880-cc chopped Kawasaki motorbikes with cherry-bomb exhaust tubes—like hara-kiri, kamikaze, karate and the creeping kudzu vine, a gift from the friendly people who gave us (remember?) Pearl Harbor—which, blasting sparks and chips of cylinder wall, roared shattering like spastic technical demons through the once-wide stillness of Southwestern night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one ever stopped. Except the Highway Patrol arriving promptly fifteen minutes late, radioing the report of an inexplicable billboard fire to a casually scornful dispatcher at headquarters, then ejecting self from vehicle, extinguisher in gloved hand, to ply the flames for a while with little limp gushes of liquid sodium hydrochloride (“wetter than water” because it adheres better, like soapsuds) to the pyre. Futile if gallant efforts. Dehydrated by months, sometimes years of desert winds and thirsty desert air, the pine and paper of the noblest most magnificent of billboards yearned in every molecule for quick combustion, wrapped itself in fire with the mad lust, the rapt intensity, of lovers fecundating. All-cleansing fire, all-purifying flame, before which the asbestos-hearted plutonic pyromaniac can only genuflect and pray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doc Sarvis by this time had descended the crumbly bank of the roadside under a billowing glare from his handiwork, dumped his gas can into trunk of car, slammed the lid—where a bright and silver caduceus glisters in the firelight—and slumped down in the front seat beside his driver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Next?” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He flipped away his cigar butt, out the open window into the ditch—the trace of burning arc remains for a moment in the night, a "), _c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v("retinal afterglow with rainbow-style trajectory, its terminal spatter of sparks the pot of gold—and unwrapped another Marsh-Wheeling, his famous surgeon’s hand revealing not a twitch or tremor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s work the west side,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The big car glided forward with murmurous motor, wheels crunching tin cans and plastic picnic plates on the berm, packed bearings sliding in the servile grease, the pistons, bathed in oil, slipping up and down in the firm but gentle grasp of cylinders, connecting rods to crankshaft, crankshaft to drive shaft through differential’s scrotal housing via axle, all power to the wheels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They progressed. That is to say, they advanced, in thoughtful silence, toward the jittery neon, the spastic anapestic rock, the apoplectic roll of Saturday night in Albuquerque, New Mexico. (To be an American for one Saturday night downtown you’d sell your immortal soul.) Down Glassy Gulch they drove toward the twenty-story towers of finance burning like blocks of radium under the illuminated smog.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Abbzug.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Doc?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I love you, Abbzug.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, Doc.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Past a lit-up funeral parlor in territorial burnt-adobe brick: Strong-Thorne Mortuary—“Oh Death Where Is Thy Sting?” Dive! Beneath the overpass of the Sante Fe (Holy Faith) Railroad—“Go Santa Fe All the Way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah,” sighed the doctor, “I like this. I like this….”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, but it interferes with my driving if you don’t mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“El Mano Negro strikes again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, Doc, okay, but you’re gonna get us in a wreck and my mother will sue.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“True,” he says, “but it’s worth it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beyond the prewar motels of stucco and Spanish tile at the city’s western fringe, they drove out on a long low bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stop here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stopped the car. Doc Sarvis gazed down at the river, the Rio "), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v("Grande, great river of New Mexico, its dark and complicated waters shining with cloud-reflected city light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My river,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Our river.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Our river.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s take that river trip.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Soon, soon.” He held up a finger. “Listen….”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They listened. The river was mumbling something down below, something like a message: Come flow with me, Doctor, through the deserts of New Mexico, down through the canyons of Big Bend and on to the sea the Gulf the Caribbean, down where those young sirens weave their seaweed garlands for your hairless head, O Doc. Are you there? Doc?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Drive on, Bonnie. This river aggravates my melancholia.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not to mention your self-pity.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My sense "), _c('em', [_vm._v("of déjà vu")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Mein Weltschmerz.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your "), _c('em', [_vm._v("Welt-schmaltz")]), _vm._v(". You love it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well….” He pulled out the lighter. “As to that, who can say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, Doc.” Watching the river, driving on, watching the road, she patted his knee. “Don’t think about all that anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doc nodded, holding the red coil to his cigar. The glow of the lighter, the soft lights of the instrument panel, gave to his large and bony, bald but bearded head a hard-worn dignity. He looked like Jean Sibelius with eyebrows and whiskers, in the full vigor of his fruitful forties. Sibelius lived for ninety-two years. Doc had forty-two and a half to go.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abbzug loved him. Not much, perhaps, but enough. She was a tough piece out of the Bronx but could be sweet as "), _c('em', [_vm._v("apfelstrudel")]), _vm._v(" when necessary. That classic Abbzug voice might rasp on the nerves at times, when her mood was querulous, but kisses or candy or con could usually mellow the harshest of her urban tones. Her tongue though adder-sharp was sweet (he thought) as Mogen David all the same.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v("His mother also loved him. Of course his mother had no choice. That’s what she was paid for.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His wife had loved him, more than he deserved, more than realism required. Given sufficient time she might have outgrown it. The children were all grown up and a continent away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doc’s nicer patients liked him but didn’t always pay their bills. He had a few friends, some poker-playing cronies on the Democratic County Committee, some drinking companions from the Medical Arts Clinic, a couple of neighbors in the Heights. No one close. His few close friends were always sent away, it seemed, returning rarely, the bonds of their affection no stronger than the web of correspondence, which frays and fades.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was therefore proud and grateful to have a nurse and buddy like Ms. Bonnie Abbzug at his side, this night, as the black automobile rose westward under the rosy smog-glow of the city’s personal atmosphere, beyond the last of the Texaco, Arco and Gulf stations, past the final Wagon Wheel Bar, into the open desert. High on the western mesa near burnt-out volcanoes, under the blazing, dazzling, starry sky, they stopped among the undefended billboards at the highway’s side. Time to choose another target.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doc Sarvis and Bonnie Abbzug looked them over. So many, all so innocent and vulnerable, ranged along the roadway in serried ranks, clamoring for the eye. Hard to choose. Should it be the military?")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE MARINE CORPS"), _c('br'), _vm._v("BUILDS")]), _vm._v(" MEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Why don’t it build women? Bonnie asked. Or how about the truckers’ editorial?")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("IF TRUCKS STOP"), _c('br'), _vm._v("AMERICA STOPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Don’t threaten "), _c('em', [_vm._v("me")]), _vm._v(", you sons of bitches. He checked out the political:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WHAT’S WRONG WITH BEING RIGHT?")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("JOIN THE JOHN BIRCH SOCIETY!")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _vm._v("But preferred the apolitical:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HAVE A NICE DAY"), _c('br'), _vm._v("WE’RE ALL IN THIS TOGETHER")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. Sarvis loved them all, but sensed a certain futility in his hobby. He carried on these days more from habit than conviction. There was a higher destiny calling to him and Ms. Abbzug. That beckoning finger in his dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bonnie—?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You might as well knock over one more, Doc. We drove all this way. You won’t be happy if you don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good girl. Which one shall it be?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bonnie pointed. “I like that one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doc said, “Exactly.” He climbed out of the car and stumbled to the back, through the tin-can tumbleweed community of the roadside ecology. He opened the trunk lid and removed, from among the golf clubs, the spare tire, the chain saw, the case of spray paint, the tire tools, the empty gas can, another gasoline can, full. Doc closed the lid. Across the length of his rear bumper a luminous sticker proclaimed in glowing red, white and blue, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("I AM PROUD TO BE AN ARMENIAN")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doc’s car carried other hex signs—he was indeed a decalcomaniac—to ward off evil: the M.D.’s caduceus, American flag decals in each corner of the rear window, a gold-fringed flag dangling from the radio aerial, in one corner of the windshield a sticker which read “Member of A.B.L.E.—Americans for Better Law Enforcement,” and in the other corner the blue eagle of the National Rifle Association with the traditional adage, “Register Communists, Not Guns.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taking no chances, looking both ways, severe and sober as a judge, carrying his matches and his can of gasoline, Dr. Sarvis marched through the weeds, the broken bottles, the rags and beer cans of the ditch, all that tragic and abandoned trivia of the American road, and climbed the cutbank toward the object of his fierymania:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("WONDER ENRICHED BREAD")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("HELPS BUILD STRONG BODIES")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("12 WAYS")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Liars!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While down below his Bonnie waited at the wheel of the Lincoln, her engines running, ready for getaway. The trucks and cars howled by on the highway and their lights shone briefly on the girl’s face, her violet eyes, her smile, and on Doc’s other bumper sticker, the one that confronted the future: "), _c('span', {
    staticClass: "small"
  }, [_vm._v("GOD BLESS AMERICA, LET’S SAVE SOME OF IT")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31068df2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795317361_epub_c01_r1.vue
// module id = 84
// module chunks = 0